<template>
    <v-container fluid>
        <v-layout>
            <v-flex><app-title>Última Ronda Realizada</app-title></v-flex>
        </v-layout>
        <v-layout>
            <v-flex>{{ lastRound.round.name }}</v-flex>
        </v-layout>
        <v-layout>
            <v-flex>Inicio</v-flex>
            <v-flex>{{ lastRound.start_date | datetime }}</v-flex>
            <v-flex>Fin</v-flex>
            <v-flex>{{ lastRound.end_date | datetime }}</v-flex>
        </v-layout>
    </v-container>
</template>
<script>
export default {

}
</script>
